import { render, staticRenderFns } from "./IntegracionExpediente.vue?vue&type=template&id=298da9e6&scoped=true&"
import script from "./IntegracionExpediente.vue?vue&type=script&lang=js&"
export * from "./IntegracionExpediente.vue?vue&type=script&lang=js&"
import style0 from "./IntegracionExpediente.vue?vue&type=style&index=0&id=298da9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298da9e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
